import React from "react";
import { FormControlLabel, Switch } from "@mui/material";

interface SwitchProps {
  label: string;
  setState: any;
  defaultValue?: boolean
  disabled?: boolean,
}
export default function NetnutSwitch({ disabled, defaultValue, label, setState }: SwitchProps) {
  const onChange = (_event: React.SyntheticEvent<Element, Event>, checked: boolean) => {
    setState(checked);
  };

  if(disabled && defaultValue){
    return <FormControlLabel
    sx={{ marginX: 1 }}
    label={label}
    checked={defaultValue}
    disabled={disabled}
    onChange={onChange}
    control={<Switch />}
  />
  }

  if(defaultValue){
    return <FormControlLabel
      sx={{ marginX: 1 }}
      label={label}
      checked={defaultValue}
      onChange={onChange}
      control={<Switch />}
    />
  }
  return (
    <FormControlLabel
      sx={{ marginX: 1 }}
      label={label}
      onChange={onChange}
      control={<Switch />}
    />
  );
}
